<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :items="items" :headers="headers" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item, index }">
                            <tr>
                                <td>{{ (index + 1) }}</td>
                                <td>{{ item.ReportDate | display_date('DD-MM-YYYY') }}</td>
                                <td class="text-end">{{ item.Amount | currency('') }}</td>
                                <td>{{ item.MethodName }}</td>
                                <td>{{ item.FeeTypeName }}</td>
                                <td>{{ item.Content }}</td>
                                <td>{{ item.Note }}</td>
                                <td class="text-center">
                                    <v-icon :disabled="!(adminRole || paymentRole)" medium class="mr-2" @click="openDetail(item)">fa-edit</v-icon>
                                    <v-icon :disabled="!(adminRole || paymentRole)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="summary">
                            <tr class="total-summary-td">
                                <td class="font-weight-bold" colspan="2">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary.Amount | currency }}</td>
                                <td class="text-end font-weight-bold" colspan="5"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialogUpdate" persistent max-width="700px">
            <v-card>
                <v-card-title>
                    <span class="title">Lệnh chi</span>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap pa-3>
                        <v-flex lg12 md12 sm12>
                            <mh-date-picker plabel="Ngày chi" class="input-group--focused date-picker px-3" v-model="report_date" @onChangeDate="report_date =$event"></mh-date-picker>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <h-currency-input v-model="currentItem.Amount" :decimal="0" label="Số tiền" class="input-group--focused"></h-currency-input>
                        </v-flex>
                        <v-flex lg6 md6 sm6>
                            <v-select label="Hình thức" class="input-group--focused" :items="config_methods" v-model="currentItem.Method" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg6 md6 sm6>
                            <v-select label="Loại chi" class="input-group--focused" :items="config_feetypes" v-model="currentItem.FeeType" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-textarea rows="3" v-model="currentItem.Content" label="Nội dung chi" class="input-group--focused"></v-textarea>
                        </v-flex>
                        <v-flex lg12 md12 sm12>
                            <v-text-field v-model="currentItem.Note" label="Ghi chú" class="input-group--focused"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" dark @click="dialogUpdate = false">Đóng</v-btn>
                    <v-btn color="blue darken-1" dark @click="saveItem(currentItem)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
export default {
    components: {
        "hpo-filter": Filtering,
        "mh-date-picker": MHDatePicker
    },
    data() {
        return {
            dialogUpdate: false,
            headers: [
                {
                    text: "STT",
                    filterable: false,
                    dataType: configs.DATA_TYPE['Number']
                },
                {
                    text: "Ngày",
                    value: "ReportDate",
                    filterable: true,
                    width: 120,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Số tiền",
                    value: "Amount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Hình thức",
                    value: "MethodName",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Loại phí",
                    value: "FeeTypeName",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Nội dung chi",
                    value: "Content",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "",
                    width: 100
                }
            ],
            viewName: "bao-cao-thu-chi-tien-vnd",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: {...configs.PAGINATION, sortBy: ["ReportDate"], sortDesc: [true]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            currentItem: {},
            report_date: null,
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.reportMoneyVND.all.data,
            summary: state => state.reportMoneyVND.all.summary,
            total_rows: state => state.reportMoneyVND.all.total,
            configuration: state => state.configuration.selected,
            loading: state => state.reportMoneyVND.loading
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
        },
        config_methods() {
            const conf = this.configuration.ReExMethods ? JSON.parse(this.configuration.ReExMethods) : [];
            return conf.concat(configs.RECHARGE_METHODS);
        },
        config_feetypes() {
            return this.configuration.ReExFeeTypeVNDs ? JSON.parse(this.configuration.ReExFeeTypeVNDs) : [];
        }
    },
    methods: {
        applyFilter(filterConditions) {
            this.pagination = {
                ...configs.PAGINATION,
                sortBy: this.pagination.sortBy,
                sortDesc: this.pagination.sortDesc
            };
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            param.filter = _.filter(param.filter, p => {return p.column != 'ReportDate'});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), condition: "d_greater_than_or_equal"});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT), condition: "d_less_than_or_equal"});
            this.$store.dispatch("reportMoneyVND/getList", param);
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        },
        openDetail(item) {
            this.dialogUpdate = true;
            this.currentItem = item;
            this.report_date = this.currentItem.ReportDate ? moment(this.currentItem.ReportDate).toISOString().substr(0, 10) : null;
        },
        deleteItem(id) {
            window.getApp.$emit("REQUEST_DELETE_DATA", id);
        },
        saveItem(item) {
            const method = _.find(this.config_methods, {'value': item.Method})
            const feetype = _.find(this.config_feetypes, {'value': item.FeeType})
            this.$store.dispatch("reportMoneyVND/setDetail", {
                id: item.ID,
                data: {
                    ...item,
                    MethodName: method ? method.name : '',
                    FeeTypeName: feetype ? feetype.name : '',
                    ReportDate: this.report_date ? moment(this.report_date, 'YYYY-MM-DD').format(configs.SQL_DATE_FORMAT) : null,
                }
            });
            this.dialogUpdate = false;
        },
        createData() {
            this.currentItem = {
                ID: 0,
                Amount: 0,
            };
            this.dialogUpdate = true;
        },
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.adminRole || this.paymentRole)});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("reportMoneyVND/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>